import { useWallet } from '../contexts/WalletContext';
import { useCallback, useState } from 'react';

export const useWalletAction = () => {
  const { isConnected, connectWallet } = useWallet();
  const [showWalletModal, setShowWalletModal] = useState(false);
  const [walletModalMessage, setWalletModalMessage] = useState('');

  const requireWallet = useCallback((action, actionName = 'perform this action') => {
    if (!isConnected) {
      // Show custom modal instead of browser alert
      const message = `You need to connect your wallet to ${actionName}.`;
      setWalletModalMessage(message);
      setShowWalletModal(true);
      return false;
    }
    return true;
  }, [isConnected]);

  const withWalletCheck = useCallback((action, actionName) => {
    return (...args) => {
      if (requireWallet(action, actionName)) {
        return action(...args);
      }
    };
  }, [requireWallet]);

  const closeWalletModal = useCallback(() => {
    setShowWalletModal(false);
    setWalletModalMessage('');
  }, []);

  return {
    requireWallet,
    withWalletCheck,
    isConnected,
    showWalletModal,
    walletModalMessage,
    closeWalletModal
  };
};
